import { AppConfigContext } from '@config/AppConfig';
import { EConstructionRemovalCertPermission, ERolePermission } from '@userProfile/permission/permission.constants';
import { isPermittedAsSiteOperationUser, isPermittedAsSystemUser } from '@userProfile/permission/permission.services';
import { useContext } from 'react';
import { EProjectTypeName } from '@project/project.constants';
import { EPermitToLoadStatus } from './permitToLoadRemove.models';

export const useAllowNewT4 = () => {
  const appConfigs = useContext(AppConfigContext);

  if (appConfigs.configs.project?.type?.name === EProjectTypeName.TENDER) return false;

  // // TODO check master schedule type
  // if (masterScheduleIsCancelled || masterScheduleType === 'D' || masterScheduleType === 'H') return false;
  const rolePermission =
    isPermittedAsSiteOperationUser(appConfigs.configs.myPermissions, [
      ERolePermission.TEMPORARY_WORK_COORDINATOR,
      ERolePermission.TEMPORARY_WORK_COORDINATOR_FOR_MINOR_WORKS,
      ERolePermission.PROJECT_MANAGER,
      ERolePermission.ENGINEERING_MANAGER,
      ERolePermission.SITE_ENGINEER,
    ]) ?? false;

  const actionPermission =
    isPermittedAsSiteOperationUser(appConfigs.configs.myPermissions, [EConstructionRemovalCertPermission.INITATE]) ||
    isPermittedAsSystemUser(appConfigs.configs.myPermissions, [EConstructionRemovalCertPermission.INITATE]);
  return actionPermission && rolePermission;
};

export const getNextAction = (status?: string) => {
  switch (status) {
    case EPermitToLoadStatus.WAITING_FOR_TWC:
    case EPermitToLoadStatus.WAITING_FOR_TWC_REMOVAL:
      return 'TWC';
    case EPermitToLoadStatus.WAITING_FOR_DESIGNER:
      return 'Designer';
    case EPermitToLoadStatus.WAITING_FOR_ICE:
      return 'ICE';
    case EPermitToLoadStatus.WAITING_FOR_PM:
      return 'PM';
    case EPermitToLoadStatus.WAITING_FOR_ICE_REMOVAL:
      return 'ICE';
    case EPermitToLoadStatus.COMPLETED:
      return 'Completed';
    case EPermitToLoadStatus.CANCEL:
      return 'Cancelled';
    case EPermitToLoadStatus.INITIAL:
    case EPermitToLoadStatus.TWC_REJECTED:
    case EPermitToLoadStatus.TWC_REMOVAL_REJECTED:
    case EPermitToLoadStatus.WAITING_FOR_ENG_REMOVAL:
    default:
      return 'SRP';
  }
};
